<template>
  <div class="w-full bg-[#e8ddd4] py-6 px-6">
    <div class="max-w-5xl mx-auto flex flex-col laptop:flex-row gap-6 laptop:gap-16 items-center">
      <div class="text-sm text-gray-700 shrink-0 text-center laptop:text-left">
        <p class="font-semibold">Fundadora e CEO:</p>
        <p>Amanda Estima</p>
        <p>CRP (02/19915)</p>
      </div>
      <div class="shrink-0 text-gray-700 border-2 border-gray-700 rounded-full w-12 h-12 flex items-center justify-center">
        <FontAwesomeIcon icon="hand" size="2x" />
      </div>
      <div class="text-sm text-gray-700">
        <span class="font-semibold">Atenção:</span> Este site não oferece tratamento ou aconselhamento imediato para pessoas em crise suicida. Em caso de crise, ligue para <span class="font-semibold">188 (CVV)</span> ou acesse o site <a href="https://www.cvv.org.br" target="_blank" class="underline">www.cvv.org.br</a>. Em caso de emergência, procure atendimento em um hospital mais próximo.
      </div>
    </div>
  </div>
</template>
